import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../RoleChecker";

export default function ProjectIncome({
  incomeData = [],
  openIncomeModal,
  openEditIncomeModal,
  totalProjectIncome
}) {
  const columns = [
    {
      dataField: "fund_type",
      text: "Jenis Dana",
      footer: "Total Penerimaan"
    },
    {
      dataField: "program_name",
      text: "Program",
      footer: ""
    },
    {
      dataField: "total",
      headerClasses: "text-right",
      footerClasses: "text-right",
      classes: "text-right",
      text: "Jumlah",
      formatter: cell => {
        return currencyFormatter(cell);
      },
      footer: (cell, row) => {
        // const sum = cell.reduce((prev, curr) => +prev + +curr, 0);
        return currencyFormatter(totalProjectIncome);
      }
    }
  ];

  return (
    <>
      <Card>
        <CardHeader title="Penerimaan">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <>
                <button
                  className="btn btn-outline-info mr-4"
                  onClick={openEditIncomeModal}
                >
                  Edit Tautan Donasi
                </button>
                <button className="btn btn-primary" onClick={openIncomeModal}>
                  Tambah Tautan Donasi
                </button>
              </>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered={false}
            remote
            keyField="uuid"
            data={incomeData}
            columns={columns}
          />
        </CardBody>
      </Card>
    </>
  );
}
